module.exports = __webpack_public_path__ + "img/eyein-partner-fortinet.3fef7e1a.webp";